<template>
  <main>
    <section class="section">
      <div class="container">
        <user-menu></user-menu>
      </div>
      <div class="container m-t-lg">
        <vue-page-transition name="fade">
          <router-view name="user"></router-view>
        </vue-page-transition>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  components: {
    UserMenu: () =>
      import(/* webpackChunkName: "UserMenu" */ "@/components/user/UserMenu")
  },
  metaInfo() {
    return {
      title: "Кабинет"
    };
  }
};
</script>
